import { Injectable } from '@angular/core';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class SlackIntegrationService {

  constructor(private rest : RestService) { }

  public getSlackWorkspaces() { 
    return this.rest.get("getSlackWorkspaces", null);
  }

  public getSlackWorkspaceChannels(payload: any) { 
    return this.rest.get("getSlackWorkspaceChannels", payload, null);
  }
}
